import { ACTION_AUTHENTICATION_COLLABORATOR, ACTION_AUTHENTICATION_VEHICLE } from "../actions/authentication";

let initialReducer = {
    collaborator: {
        document: '',
        name: '',
        companyUnit: '',
        role: ''
    },
    vehicle: {
        code: '',
        identity: '',
        companyUnit: '',
    }
}

let TotemReducers = (state = initialReducer, action) => {
    switch (action.type) {
        case ACTION_AUTHENTICATION_COLLABORATOR.type:
            return {
                ...state,
                collaborator: {
                    document: action.payload.document,
                    name: action.payload.name,
                    companyUnit: action.payload.companyUnit,
                    role: action.payload.role,
                }
            };
        case ACTION_AUTHENTICATION_VEHICLE.type:
            return {
                ...state,
                vehicle: {
                    code: action.payload.code,
                    identity: action.payload.identity,
                    companyUnit: action.payload.companyUnit,
                }
            };
        default:
            return state;
    }
}

export default TotemReducers